import React from 'react';
import { mountOn } from './lib/mount';
import { AppEditor } from './components/app_editor';

function RenderRoot() {
  const dataEl = document.getElementById('render-document');
  const raw = dataEl?.textContent;
  if (!raw) return null;

  const doc = JSON.parse(raw);
  return <AppEditor document={doc} readOnly />;
}

mountOn('render-root', <RenderRoot />);
